import { useReportCanonicalRumViewName } from '@ctw/shared/context/telemetry/use-rum-view-name';
import { ZapProvider } from '@ctw/shared/context/zap-context';
import { ZuiProvider } from '@ctw/shared/context/zui-provider';
import { createBrowserRouter, Outlet, useLocation, useRouteError } from 'react-router';
import { RouterProvider } from 'react-router/dom';
import ZAPV2 from './ZAP-v2';

const RootLayout = () => {
  const location = useLocation();

  useReportCanonicalRumViewName(location.pathname);

  return (
    <ZuiProvider service="zap-sof" navigatePersistentQueryParams={['ehr']}>
      <ZapProvider>
        <Outlet />
      </ZapProvider>
    </ZuiProvider>
  );
};

const RethrowRouteError = (): never => {
  throw useRouteError();
};

const router = createBrowserRouter([
  {
    element: <RootLayout />,
    errorElement: <RethrowRouteError />,
    children: [
      { path: '/zap-v2/*', Component: ZAPV2 },
      { path: '*', element: null },
    ],
  },
]);

export function App() {
  return <RouterProvider router={router} />;
}
